import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxServerSchema } from "../../Schemas/PbxServer";
import {
  ISortSchema,
  IFilterSchema,
  IListQueryStringSchema,
} from "../../Schemas/ListQueryString";


export interface PbxServersDetailsResponseBody extends IResponseBody {
  data: {
    pbxServer: PbxServerSchema;
    voice_broadcasts_report: {
      sent: number;
      failed: number;
      sending: number;
      total_pickup: number;
      created_at_timestamp: number;
    };
  };
}
export interface PbxServerResponseBody extends IResponseBody {
  data: {
    pbx_servers: PbxServerSchema[];
  };
}
interface Filter extends IFilterSchema {
  column: PbxServerListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PbxServerListColumnSortable;
}

export enum PbxServerListColumnFilterable {
  ID = "id",
  STATUS = "status",
  PBX_SERVER_ID = "pbx_server_id",
}
export enum PbxServerListColumnSortable {
  ID = "id",
  STATUS = "status",
  CREATED_AT="created_at",
  PBX_SERVER_ID = "pbx_server_id",
}

export interface PbxServersListQueryString extends IListQueryStringSchema {
  sorts?: Sort[];
  filters?: Filter[];
}

export class PbxServersListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/pbx-servers`;
  }
  
  async details(PbxServerId: number): Promise<PbxServersDetailsResponseBody> {
      try {
        const { data } = await this.protectedAxiosInstance.get(
          this.getPath() + `/${PbxServerId}/details`
        );
        return data;
      } catch (err) {
        // TODO : handle error
        throw err;
      }
  }


  async list(
    queryStrings?: PbxServersListQueryString
  ): Promise<PbxServerResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  async send(
    queryStrings?: PbxServersListQueryString
  ): Promise<PbxServerResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
